import React from 'react';
import styled from 'styled-components';

import { useMedia } from '@tager/web-core';

import CarTags from '@/components/CarTags';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import { getDetailedCarTags } from '@/modules/DetailedCar/DetailedCar.helper';
import CarTag from '@/components/CarTags/components/CarTag';
import { getStockStatusText } from '@/modules/CarsStock/components/common.helpers';

function Tags() {
  const isLaptopOnly = useMedia('(max-width: 1539px) and (min-width: 1260px)');
  const isMobile = useMedia('(max-width: 767px)');
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const { stockStatus, inStockCount } = data;

  return (
    <Component>
      <CarTags
        {...getDetailedCarTags(data)}
        isLaptop={isLaptopOnly || isMobile}
      />

      {stockStatus && inStockCount > 0 && (
        <CarTag
          isLaptop={isLaptopOnly || isMobile}
          title={getStockStatusText(stockStatus.id, inStockCount)}
        />
      )}
    </Component>
  );
}

export default Tags;

const Component = styled.div`
  margin-top: 15px;
`;
